<!-- 水表厂家在线率、故障率 -->
<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
      </div>
    </div>
    <div class="m-panel-body">
      <!-- <Echart ref="option" :options="option" style="height: 100%"></Echart> -->
      <div ref="option" id="chart" style="height: 100%;width: 100%;"></div>
    </div>
  </div>
</template>
<script>
  // import echarts from 'echarts/lib/echarts';
  import echarts from 'echarts';
  import {
    postAction
  } from '@/api/manage'
  export default {
    props: {
      titleImage: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        title: this.$t('水表在线率/故障率'),
        url: {
          queryLargeScreenMeterFactory: "/jeecg-charge/meter/meterReadingLargeScreen/queryLargeScreenMeterFactory"
        },
        option: {},
      }
    },
    mounted() {},
    methods: {
      init() {
        this.getData();
      },
      getData(){
        postAction(this.url.queryLargeScreenMeterFactory,{}).then(res=>{
          if(res.success){
            var data = res.result;
            this.setOption(data);
          }
        })
      },
      setOption(list) {
        var chartDom = document.getElementById('chart');
        var myChart = echarts.init(chartDom);
        var xData = list.xdata;
        var yData = [];
        var yData1 = [];
        list.ydata.map(item=>{
          yData.push(item.num);
          yData1.push(item.rate*100);
        })
        this.option = {
          textStyle: {
            color: '#fff'
          },
          grid: {
            top: '15%',
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          tooltip: {
              trigger: 'axis',
              formatter: '{b}<br />{a0}: {c0}<br />{a1}: {c1}%',
              backgroundColor: 'rgba(0,11,42,0.9)',
              borderColor: '#5D6A94',
              borderWidth: 1,
              borderRadius: 8,
              textStyle: {
                  color: '#CEE2FF',
              },
              axisPointer: {
                  type: 'line',
                  lineStyle: {
                      color: '#019AF3'
                  }
              }
          },
          legend: {
            show: true,
            // bottom: '30',
            itemHeight: 10,
            right: 'center',
            textStyle: {
              color: '#CEE2FF'
            },
          },
          color: ['rgb(105,211,137)','#F45535'],
          xAxis: [{
            type: 'category',
            data: xData,
            splitLine: {
              show: false
            },
            axisTick:{
                show: false
            },
            axisLine: {
                show: false
            },
            axisLabel: {
                color: '#D1F3FF',
                fontSize: 10
            },
            axisPointer: {
              type: 'shadow'
            },
          }],
          yAxis: [{
              type: 'value',
              name: this.$t('数量(个)'),
              axisLabel: {
                textStyle: {
                    color: '#D1F3FF',
                    fontSize: 12,
                },
                formatter: '{value}'
              },
              splitLine: {
                  show: true,
                  lineStyle: {
                      type: 'dotted',
                      color: ['#074671'],
                  }
              },
              axisTick:{
                  show: false
              },
              axisLine: {
                  show: false
              },
            },
            {
              type: 'value',
              min: 0,
              max: 100,
              interval: 20,
              name: this.$t('故障率(%)'),
              nameTextStyle: {
                color: '#D1F3FF',
                align: 'center',
              },
              splitLine: {
                show: false,
                lineStyle: {
                  type: 'dotted',
                  color: ['#074671'],
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value} %',
                color: '#D1F3FF',
                fontSize: 10
              }
            }
          ],
          series: [
            {
              name: this.$t('数量'),
              type: 'bar',
              barWidth: 15,
              tooltip: {
                formatter: function(value) {
                  return value + '%';
                }
              },
              data: yData,
              itemStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                        offset: 0,
                        color: 'rgb(105,211,137)',
                    },
                    {
                        offset: 0.5,
                        color: 'rgba(105,211,137,0.5)',
                    },
                    {
                        offset: 1,
                        color: 'rgba(105,211,137,0.1)',
                    },
                  ],
                  global: false,
                },
              },
              // label: {
              //   show: true,
              //   color: '#D1F3FF',
              //   position: 'top',
              //   fontSize: 14,
              //   formatter: function(value) {
              //     return value.value + '%';
              //   }
              // }
            },
            {
              name: this.$t('故障率'),
              type: 'line',
              barWidth: 15,
              barGap: "10%",
              tooltip: {
                formatter: function(value) {
                  return value + '%';
                }
              },
              data: yData1,
              itemStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                        offset: 0,
                        color: '#F45535',
                    },
                    {
                        offset: 0.5,
                        color: 'rgba(244,85,53,0.5)',
                    },
                    {
                        offset: 1,
                        color: 'rgba(244,85,53,0.1)',
                    },
                  ],
                  global: false,
                },
              },
              // label: {
              //   show: true,
              //   color: '#D1F3FF',
              //   position: 'top',
              //   fontSize: 14,
              //   formatter: function(value) {
              //     return value.value + '%';
              //   }
              // }
            },
          ]
        }
        this.option && myChart.setOption(this.option);
      }
    },
  }
</script>
<style lang="less" scoped>
  .tabs {
    display: flex;
    position: absolute;
    right: 0;
  }

  .tab {
    padding: 6px 8px;
    margin: 0 0 0 0;

    cursor: pointer;
  }

  .tab-active {
    position: relative;
  }

  .tab-active::before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #019AF3;
    transition: all .3s;

  }

  .tab:last-child {

    margin-right: 0;
  }

  .tab-title {
    font-size: 12px;
    font-weight: normal;
    color: #7993b3;
    cursor: pointer;
  }

  .tab-active .tab-title {
    color: #cbdff7;
    position: relative;
    font-weight: 500;
  }

  .trends-box {}
  .ant-radio-button-wrapper{
    color: #fff;
    background: transparent;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
    color: #1890FF;
  }
</style>